import script from "./CaskMainVideoContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskMainVideoContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBars,QIcon,QVirtualScroll,QBtn});
